// 全局共享数据示例
import { ConstantEnumsVO } from '@/client/common/Type/ConstantEnumsVO'
import { constantenums } from '@/client/common/apis/constantenums'
import { UserInfoVO } from '@/client/home/Type/UserInfoVO'
import { userInfo } from '@/client/home/apis/userInfo'
import { coronaMonitor } from '@/global'
import OldAppComponents from '@/pages/OldApp/components/index'
import { useSetState } from 'ahooks'
import { message } from 'antd'
import React, { useCallback, useEffect } from 'react'
import { createRoot } from 'react-dom/client'

const useGlobal = () => {
	const [state, setState] = useSetState<{
		userInfo: Partial<UserInfoVO>
		commonEnums?: ConstantEnumsVO
		navigationPermissions: string[] // 导航权限列表
		menuRequestPermissionMap: { [key: string]: string[] } // 导航下接口权限映射
		isLogin: boolean
		isInitLoadSuccess: boolean // 初始化是否成功
	}>({
		userInfo: {},
		navigationPermissions: [],
		menuRequestPermissionMap: {},
		isLogin: false,
		isInitLoadSuccess: false,
	})

	useEffect(() => {
		// 登录页不获取用户信息
		if (location.pathname === '/') return
		// 初始化全局枚举类型
		Promise.all([userInfo({ passResponseHandler: true }), constantenums({ passResponseHandler: true })]).then(
			([data, res]) => {
				setState({ isInitLoadSuccess: true })
				if (data.res === 200) {
					setState({
						isLogin: true,
						userInfo: data.msg,
						commonEnums: res.msg,
						menuRequestPermissionMap: data.msg?.menuRequestPermissionMap || {},
						navigationPermissions: data.msg?.menuRequestPermissionMap?.['/'] || [],
					})
					if (coronaMonitor) coronaMonitor.setUser(data.msg.accid)
				} else if (data.res === 401) {
					setState({ isLogin: false })
				} else {
					message.error(data.errmsg || '获取用户信息失败')
				}
			},
		)
	}, [])

	/**
	 * 判断路由与接口权限
	 */
	const hasMenuPermissions = useCallback(
		(key: string) => {
			const requestPermissions = state.userInfo?.requestPermissions || []
			return requestPermissions.includes(key)
		},
		[location.pathname, state.userInfo],
	)
	/**
	 * 判断当前路由权限中是否包含某个权限
	 */
	const hasRouterPermissions = useCallback(
		(key: string) => {
			const permissions = state.menuRequestPermissionMap[location.pathname] || []
			return permissions.includes(key)
		},
		[location.pathname, state.userInfo],
	)
	/**
	 * 判断菜单展示权限
	 */
	const hasNavigationPermissions = useCallback(
		(key: string) => {
			const navigationPermissions = state.userInfo?.menuRequestPermissionMap?.['/'] || []
			return navigationPermissions.includes(key)
		},
		[state.userInfo],
	)
	return {
		userInfo: state.userInfo,
		commonEnums: state.commonEnums,
		isLogin: state.isLogin,
		isInitLoadSuccess: state.isInitLoadSuccess,
		hasNavigationPermissions,
		hasMenuPermissions,
		hasRouterPermissions,
		menuRequestPermissionMap: state.menuRequestPermissionMap,
		navigationPermissions: state.navigationPermissions,
		callParentComponent: (params: {
			componentName: keyof typeof OldAppComponents
			props: any
			containerDom: Element
		}) => {
			const { componentName, props, containerDom } = params
			const component = OldAppComponents[componentName]
			const root = createRoot(containerDom)
			root.render(React.createElement(component, { ...props, componentRoot: root }))
		},
	}
}

export default useGlobal
